import { render, staticRenderFns } from "./charts-item.vue?vue&type=template&id=1c6d59bd&scoped=true"
import script from "./charts-item.vue?vue&type=script&lang=js"
export * from "./charts-item.vue?vue&type=script&lang=js"
import style0 from "./charts-item.vue?vue&type=style&index=0&id=1c6d59bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d59bd",
  null
  
)

export default component.exports